import firebase from '../../lib/firebase.prod';
import * as PROJECT_CODE from '../../constants/projectCode';

const firebaseRef = firebase.database();

export default async function savePersistedData(section, data) {
	return {
		[section]: data,
	};
}
